import React from 'react';
import { Button, notification, Popconfirm } from 'antd';
import { ButtonProps } from 'antd/lib/button';
import { SwapOutlined } from '@ant-design/icons';
import { updateAssetAddresStatus } from 'services/assets';

export type AssetAddresStatusButtonProps = ButtonProps & {
  assetid: number;
  assetadrid: number;
  status: string;
  refetch: () => void;
  fromextra?: boolean;
};

const AssetAddresStatusButton: React.FC<AssetAddresStatusButtonProps> = ({
  size = 'small',
  assetid,
  assetadrid,
  status,
  refetch,
  fromextra,
  ...props
}) => {
  let newStatus = '',
    statuslabel = '';
  switch (status) {
    case 'INIT':
      newStatus = 'VALID';
      statuslabel = 'Validate';
      break;
    case 'VALID':
      newStatus = 'END';
      statuslabel = 'Terminate';
      break;
    case 'END':
      newStatus = 'VALID';
      statuslabel = 'Validate';
      break;
  }
  return (
    <Popconfirm
      title="Sure to change the status?"
      onConfirm={() => {
        updateAssetAddresStatus({
          assetadrid,
          adrstatus: newStatus,
          assetid: assetid,
        }).then((res) => {
          notification.success({ message: res.message });
          refetch();
        });
      }}
    >
      <Button
        icon={<SwapOutlined twoToneColor="#52c41a" />}
        onClick={() => {}}
        {...props}
        style={
          fromextra
            ? { width: '100%', height: 60 }
            : {
                width: 100,
                height: 40,
                marginLeft: 5,
                marginRight: 5,
                marginBottom: 5,
              }
        }
      >
        {statuslabel}
      </Button>
    </Popconfirm>
  );
};

export default AssetAddresStatusButton;
